import { type Metadata } from 'next';
import { PageHref, Routes } from '@/constants';
import { translate } from '@/core/translations';

export type { PageHref };

export const routesMetadata: Record<PageHref, Metadata> = {
  [Routes.REGISTRATION]: { title: null },
  [Routes.REGISTRATION_PROFILE]: { title: null },
  [Routes.REGISTRATION_COMPLETE]: { title: null },
  [Routes.REGISTRATION_VERIFY_EMAIL]: { title: null },

  [Routes.ORGANIZATIONS]: { title: null },
  [Routes.ORGANIZATIONS_PICK]: { title: null },

  [Routes.LEGAL_TERMS_OF_SERVICE]: { title: null },
  [Routes.LEGAL_PRIVACY_POLICY]: { title: null },

  [Routes.AUTH_ERROR]: { title: 'Authentication Error' },

  [Routes.INDEX]: { title: 'Incident Monitoring' },
  [Routes.DASHBOARD]: { title: 'Global Forecast Overview' },
  [Routes.INCIDENTS]: { title: 'Incident Monitoring' },
  [Routes.SEARCH_CONSOLE]: { title: 'Search Console' },

  /** Settings pages */
  [Routes.SETTINGS]: { title: translate('settings_page.title') },
  [Routes.SETTINGS_ACCOUNT]: { title: translate('settings_page.account.title') },
  [Routes.SETTINGS_SUBSCRIPTION]: { title: translate('settings_page.subscription.title') },
  [Routes.SETTINGS_CACHE]: { title: translate('settings_page.cache_management.title') },

  /** Reports pages */
  [Routes.REPORTS]: { title: 'Reports' },
  [Routes.REPORTS_CATALOG]: { title: 'Reports Catalog' },
  [Routes.REPORTS_COPILOT]: { title: 'AI Assistant' },

  /** Narrative Intelligence pages */
  [Routes.NARRATIVE_INTELLIGENCE]: { title: 'Narrative Intelligence' },
  [Routes.NARRATIVE_INTELLIGENCE_NARRATIVES]: { title: 'Narratives' },
  [Routes.NARRATIVE_INTELLIGENCE_NETWORKS]: { title: ' Networks' },

  /** Supply Chain pages */
  [Routes.SUPPLY_CHAIN]: { title: 'Supply Chain Mapping' },

  /** Embedded apps pages */
  [Routes.EMBEDDED_SUPPLY_CHAIN]: { title: 'Supply Chain App' },
  [Routes.EMBEDDED_INTELLIGENCE_DASHBOARD]: { title: 'Intelligence Dashboard' },
  // TEMP(ankara-poc-demo): Ankara NATO POC demo — remove after the demo.
  [Routes.EMBEDDED_ANKARA_POC]: { title: 'Ankara NATO' },

  /** Geopolitical Intelligence pages */
  [Routes.GEOPOLITICAL_INTELLIGENCE]: { title: 'Geopolitical Intelligence' },
  [Routes.GEOPOLITICAL_INTELLIGENCE_INCIDENTS]: { title: 'Incidents' },
  [Routes.GEOPOLITICAL_INTELLIGENCE_TRADE]: { title: 'Trade' },
  [Routes.GEOPOLITICAL_INTELLIGENCE_ACTIONS]: { title: 'Action Menu' },
};

export enum PageTitleMode {
  ROOT = 'root',
  SUB_ROUTE = 'sub_route',
  FULL = 'full',
}

export const getPageTitle = (page: PageHref, { mode }: { mode?: PageTitleMode } = {}) => {
  const pageTitle = routesMetadata[page]?.title as string;
  const parentHref = page.split('/').slice(0, -1).join('/') as PageHref;

  switch (mode) {
    case PageTitleMode.ROOT:
      return (routesMetadata[parentHref]?.title || pageTitle) as string;
    case PageTitleMode.SUB_ROUTE:
      return pageTitle?.split('/').pop()?.trim() as string;
    case PageTitleMode.FULL:
    default:
      return pageTitle;
  }
};
